import React, { useEffect } from 'react';
import { ApkScriptSourceBuilder } from '../../../helpers/ApkUrlBuilder';
import CustomEvents from '../../../helpers/CustomEvents';
import { CalculateStore } from '../../../stores/calculateStore';
import { UiFlagsStore } from '../../../stores/uiFlagsStore';
import './apkWebComponent.scss'; // Importujemy plik SCSS


// custom element declaration to bypass ts type checking
declare global {
  interface Window {
    tuzApkManager: any;
  }
}

interface MyComponentProps {
  uiFlagsStore?: UiFlagsStore;
  calculationstore?: CalculateStore;
}

const ApkWebComponent: React.FC<MyComponentProps> = ({ uiFlagsStore, calculationstore }) => {
  useEffect(() => {
    const initializeTuzApkManager = () => {
      const scriptSrc = ApkScriptSourceBuilder.getScriptSource(uiFlagsStore?.isDirect, uiFlagsStore?.environment);
      //const scriptSrc = "http://localhost:4214/assets/scripts/env/testing/tuz-apk-manager.js";

      const script = document.createElement('script');
      script.src = scriptSrc;
      script.async = true;
      document.body.appendChild(script);
      script.onload = prepareScript;
    };

    const prepareScript = () => {
      //@ts-ignore
      window.tuzApkManager = new TuzApkManager();
      const config = {
        tariffId: 40,
        sourceType: uiFlagsStore?.partnerName.toUpperCase(),
        apkUuid: '',
        readonly: false,
        hideSubmitButton: false,
        selectedAnswers: calculationstore ? calculationstore.getApkAnswers : [],
      };
      window.tuzApkManager.option(config);
    };

    const updateTuzApkManager = () => {
      const apkConfig = {
        tariffId: 40,
        sourceType: uiFlagsStore?.partnerName === 'directTuz' ? 'DIRECT' : uiFlagsStore?.partnerName.toUpperCase(),
        apkUuid: '',
        readonly: false,
        hideSubmitButton: false,
        selectedAnswers: calculationstore ? calculationstore.getApkAnswers : [],
      };
      const apkConfigEvent = new CustomEvent(CustomEvents.ApkPassUpdatedConfig, {
        detail: apkConfig
      });
      window.dispatchEvent(apkConfigEvent);
    };
    window.tuzApkManager ? updateTuzApkManager() : initializeTuzApkManager();
  }, [uiFlagsStore, calculationstore]);

  return (
      <div>
      </div>
  );
};

export default ApkWebComponent;


